import React from 'react';
import { Search, X } from 'lucide-react';

interface SectionSearchBarProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  onClearSearch: () => void;
  placeholder: string;
  language: 'ar' | 'en';
  isRTL?: boolean;
}

const SectionSearchBar: React.FC<SectionSearchBarProps> = ({
  searchQuery,
  onSearchChange,
  onClearSearch,
  placeholder,
  language,
  isRTL
}) => {
  // Determine RTL state - use isRTL if provided, otherwise fall back to language
  const isRTLMode = isRTL !== undefined ? isRTL : language === 'ar';
  
  return (
    <div className="relative flex-1 max-w-md">
      <div className="relative">
        <input
          type="text"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder={placeholder}
          className={`w-full py-2 px-4 border border-slate-300 dark:border-slate-600 rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent dark:bg-slate-700 dark:text-white ${
            isRTLMode ? 'text-right' : 'text-left'
          }`}
          style={{
            textAlign: isRTLMode ? 'right' : 'left'
          }}
        />
        {searchQuery && (
          <button
            onClick={onClearSearch}
            className={`absolute top-1/2 transform -translate-y-1/2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-300 transition-colors ${
              isRTLMode ? 'right-3' : 'left-3'
            }`}
            title={language === 'ar' ? 'مسح البحث' : 'Clear search'}
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
};

export default SectionSearchBar;
